import React, { useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { isLoggedIn } from "./../../util";
import {
  dismissLogs,
  initiateUpload,
  furlencoUploadMasterCsv,
  jandjDealersCV,
  jandjMasterCV,
} from "../../actions/control_panel_action";
import { Dimmer, Loader } from "semantic-ui-react";
import { Button, Modal } from "semantic-ui-react";
import CommonForAllPannels from "./CommonForAllPannels.jsx";
import CommonPanel from "./commonPanel.jsx";
import { Header } from "semantic-ui-react";
var assignfile = {};
const JohnsonControlPanel = (props) => {
  useEffect(() => {
    if (!isLoggedIn(props.auth)) {
      props.history.push(`/login`);
    }
  }, [props.auth]);

  const jandjDealerFileUpload = (file) => {
    console.log(file.target.files[0], "fileupload....");
    assignfile = file.target.files[0];
  };

  const jandjmasterFileUpload = (file) => {
    console.log(file.target.files[0], "fileupload....");
    assignfile = file.target.files[0];
  };

  const jandjuploadDealerData = () => {
    console.log(assignfile, "uploading.....");
    props.initiateUpload(true);
    props.uploadjandjdealerCV(assignfile);
  };

  const jandjuploadMasterData = () => {
    console.log(assignfile, "uploading.....");
    props.initiateUpload(true);
    props.uploadjandjmasterCV(assignfile);
  };

  let jandjPannel = [
    {
      itemForSpan: " Upload CSV to add Dealers",
      itemInputChange: jandjDealerFileUpload,
      itemClickButton: jandjuploadDealerData,
      itemContentForButton: "Upload Dealers CSV",
    },
  ];

  let jandjMasterPannel = [
    {
      itemForSpan: " Upload CSV to add master Customers",
      itemInputChange: jandjmasterFileUpload,
      itemClickButton: jandjuploadMasterData,
      itemContentForButton: "Upload Masters CSV",
    },
  ];

  const jandjcloseLog = () => {
    props.dismissLogs(false);
  };

  return (
    <div
      style={{
        marginLeft: "2vw",
        marginTop: "7vh",
        fontWeight: "bold",
        fontFamily: "Arial, Helvetica, sans-serif",
      }}
    >
      <Dimmer active={props.controlPanel.uploadIncomplete}>
        <Loader size="massive">Uploading</Loader>
      </Dimmer>

      <CommonForAllPannels child={jandjPannel} color={props.color} />

      <CommonForAllPannels child={jandjMasterPannel} color={props.color} />

      {props.controlPanel.showLog && (
        <Modal close={jandjcloseLog} open={props.controlPanel.showLog}>
          <Modal.Header>Upload Report</Modal.Header>
          <Modal.Content>
            <div
              dangerouslySetInnerHTML={{
                __html: props.controlPanel.log,
              }}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={jandjcloseLog}>
              Dismiss
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    home: state.home,
    controlPanel: state.controlPanel,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      uploadjandjmasterCV: jandjMasterCV,
      uploadjandjdealerCV: jandjDealersCV,
      initiateUpload: initiateUpload,
      dismissLogs: dismissLogs,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(JohnsonControlPanel)
);
